import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { Box } from "@mui/system"
import { ReactNode } from "react"

interface Props extends React.PropsWithChildren {
    label: string | ReactNode
}

const useStyles = makeStyles()((theme) => ({
    root: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "0.5rem",
    },
    label: {
        color: theme.palette.tailwind.slate[600],
        lineHeight: "1.2",
    },
}))

export default function HeaderFilter({ children, label }: Props) {
    const { classes } = useStyles()

    return (
        <Box className={classes.root}>
            {typeof label === "string" ? (
                <Typography variant="body1" className={classes.label}>
                    {label}
                </Typography>
            ) : (
                <Typography variant="body1" className={classes.label} component="span">
                    {label}
                </Typography>
            )}
            {children}
        </Box>
    )
}

